<template>
  <div v-if="user.role == 'employee'">
    <EmployeeCalendar />
  </div>

  <div v-else-if="user.role == 'client'">
    <ClientCalendar />
  </div>

  <div v-else-if="user.role == 'manager'">
    <ManagerCalendar />
  </div>

  <div v-else-if="user.bohOrHigher">
    <AdminCalendar />
  </div>

</template>

<script>
import AdminCalendar from '@/components/calendar/admin-calendar-wrapper.vue'
import ManagerCalendar from '@/components/calendar/manager-calendar-wrapper.vue'
import ClientCalendar from '@/components/calendar/client-calendar-wrapper.vue'
import EmployeeCalendar from '@/components/calendar/employee-calendar-wrapper.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    AdminCalendar,
    ManagerCalendar,
    ClientCalendar,
    EmployeeCalendar,
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  }
}
</script>

<style scoped>
#dashboard-container {
}

.my-event {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  border-radius: 2px;
  border: 1px solid #1867c0;
  font-size: 12px;
  padding: 3px;
  cursor: pointer;
  margin-bottom: 1px;
  left: 4px;
  margin-right: 8px;
  position: relative;
}

.my-event.with-time {
  position: absolute;
  right: 4px;
  margin-right: 0px;
}

.shift-overflow-count {
  position: absolute;
  top: 0px;
  right: 0px;
}

</style>

<style>
.vss-calendar.v-calendar.timeframe-week-available .v-calendar-daily__body {
  display: none !important;
}

.vss-calendar.v-calendar.timeframe-day-available .v-calendar-daily__body {
  display: none !important;
}

.vss-calendar .v-calendar-weekly__day {
  max-height: 140px !important;
  overflow-y: scroll !important;
  overflow-x: hidden !important;
}

.vss-calendar .v-calendar-weekly__day::-webkit-scrollbar { width: 0 !important; }
.vss-calendar .v-calendar-weekly__day { overflow: -moz-scrollbars-none !important; }
.vss-calendar .v-calendar-weekly__day { -ms-overflow-style: none !important; }

.shift-overflow-count .v-chip__content {
  cursor: pointer !important;
}
</style>
